<template>
  <v-card flat tile min-height="400" color="#7c7b7b">
    <div class="heading text-center white--text">Contact Us</div>
    <v-row>
      <v-col cols="12" sm="6" class="text-center"
        ><div
          class="slogan text-left primary--text ml-15"
          style="max-width: 70%"
        >
          Share in the journey.
          <br />
          <br />
          Let us know what food you think deserve this mark of quality and be
          part of the change.
          <br />
          <br />
          Help us tag it!
        </div></v-col
      >
      <v-col cols="12" sm="6" class="text-center"
        ><div class="sub-heading white--text">get in touch</div>
        <div class="body white--text">
          <v-icon color="#A6CE39" class="mr-2">email</v-icon>info@foodtag.co.za
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      message: `Share in the journey.Let us know what food you think deserve this mark of quality and be part of the change.`,
    };
  },
};
</script>

<style scoped>
div {
  background-color: #272727;
}
</style>
